import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const MailIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 21 14"
      fill="none"
      xmlns="http://www.w3.org/2000/Icon"
      style={{ width: '24px', height: '24px' }}
      {...props}
    >
      <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.25 0.599976H1.65C0.7403 0.599976 0 1.34028 0 2.24998V12.15C0 13.0597 0.7403 13.8 1.65 13.8H19.25C20.1597 13.8 20.9 13.0597 20.9 12.15V2.24998C20.9 1.34028 20.1597 0.599976 19.25 0.599976ZM19.25 1.69998C19.283 1.69998 19.3138 1.70328 19.3457 1.70878L11.0605 7.23188C10.7415 7.44418 10.1596 7.44418 9.8406 7.23188L1.5554 1.70878C1.5862 1.70328 1.6181 1.69998 1.6511 1.69998H19.2511H19.25ZM19.25 12.7H1.65C1.3464 12.7 1.1 12.4536 1.1 12.15V2.72738L9.2301 8.14708C9.5722 8.37477 10.0111 8.48917 10.45 8.48917C10.8889 8.48917 11.3278 8.37477 11.6699 8.14708L19.8 2.72738V12.15C19.8 12.4536 19.5536 12.7 19.25 12.7Z"
          fill="black"
        />
      </svg>
    </Icon>
  );
};
